
export function elementFromObjectPath (obj, path) {
  let props = path.split('.')
  let exists = false
  let el = obj
  if (obj.hasOwnProperty(props[0])) {
    try {
      for (let prop of props) {
        el = el[prop]
      }
      if (el != null) exists = true
    } catch (err) {}
  }
  return {el, exists}
}

export function fillPlaceholdersJson (json, obj) {
  return JSON.parse(fillPlaceholders(JSON.stringify(json), obj))
}

export function fillPlaceholders (text, obj) {
  return text.replace(/({{[A-Za-z0-9_.]*}})/g, function (element) {
    element = element.slice(2, -2)
    let {el, exists} = elementFromObjectPath(obj, element)
    if (exists) return el
    else return element
  })
}

export function clearOutput (output, namespace) {
  delete output.contexto.actions.before
  delete output.contexto[namespace]
  delete output.input
  delete output.contexto._input
  return output
}



// WEBPACK FOOTER //
// ./src/utils/general.js